.inlineIcon {
  vertical-align: middle;
}
